import {
    FETCH_ESTACOES_TRABALHO,
    FETCH_LISTA_OSs,
    FETCH_METAS,
    FETCH_LOGIN_LOGOUTS,

    FETCH_PNEUS_NA_CASA,
    FETCH_PNEUS_PRODUZIDOS_HOJE,
    FETCH_PNEUS_RECEBIDOS_HOJE,
    FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE,
    FETCH_PNEUS_SAIDOS_HOJE,
    RECEIVE_DIARIOS_PRODUCAO,
    RECEIVE_ESTACOES_TRABALHO,
    RECEIVE_LISTA_OSs,
    RECEIVE_LOGIN_LOGOUTS_HOJE,
    RECEIVE_LOGIN_LOGOUTS,
    RECEIVE_METAS,
    RECEIVE_METAS_PERIODO,
    RECEIVE_OS_SLA,
    RECEIVE_PNEUS_CONCLUIDOS_POR_DATA,
    RECEIVE_PNEUS_ENVIADOS_POR_DATA,

    RECEIVE_PNEUS_NA_CASA,
    RECEIVE_PNEUS_PRODUZIDOS_HOJE,
    RECEIVE_PNEUS_RECEBIDOS_HOJE,
    RECEIVE_PNEUS_RECEBIDOS_POR_DATA,
    RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE,
    RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA,
    RECEIVE_PNEUS_SAIDOS_HOJE,
    RECEIVE_PROCESSOS,
    RECEIVE_SALDOS

} from "../actions/actionTypes";
const dataObjectFromFile = require("../assets/mock/1/state0.json");

const initalState = () => {

    const at = localStorage.getItem('accessToken');
    if (at && at == "mock"){
        return {
            ...dataObjectFromFile.i4,
            mock: 1
        }
    }

    return {
        mock: 0,
        isFetchingEstacoesTrabalho: false,
        estacoesTrabalho: [],
        isFetchingPneusNaCasa: false,
        pneusNaCasa: [],
        isFetchingPneusRecebidosHoje: false,
        pneusRecebidosHoje: [],
        isFetchingPneusSaidosHoje: false,
        pneusSaidosHoje: [],
        isFetchingPneusProduzidosHoje: false,
        pneusProduzidosHoje: [],
        recapadosHoje: [],
        consertadosHoje: [],
        retrabalhadosHoje: [],
        isFetchingLoginLogoutsHoje: false,
        loginLogoutsHoje: [],
        loginLogouts: [],


        isFetchingPneusRecusadosReprovadosHoje: false,

        pneusRecusadosHoje: [],
        pneusReprovadosHoje: [],
        recebidosPorData: [],
        enviadosPorData: [],

        recusadosPorData: [],
        reprovadosPorData: [],
        recapadosPorData: [],
        consertadosPorData: [],
        retrabalhadosPorData: [],


        processos: [],
        osSLA: [],


        isFetchingMetas: false,
        metas: [],
        metasPeriodo: {
            recapados: [],
            recusados: [],
            diasTrabalhados: []

        },
        saldos: {
            pneusEmCasaHoje: 0,
            recebidosPos: 0,
            enviadosPos: 0,
            saldoMax: 0,
            recebidos: 0,
            enviados: 0,
            saldoMin: 0,
            estabelecimentoId: 0,
            intervalo: {
                min: '',
                max: ''
            }
        },

        isFetchingDiariosProducao: false,
        diariosProducao: [],
        isFetchingListaOSs: false,
        isFetchingLoginLogouts: false,
        listaOSs: []

    }
}


export default (state = initalState(), action) => {
    switch(action.type) {
        case FETCH_ESTACOES_TRABALHO:
            return {
                ...state,
                isFetchingEstacoesTrabalho: true
           //     estacoesTrabalho: []
            }
        case RECEIVE_ESTACOES_TRABALHO:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_ESTACOES_TRABALHO ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingEstacoesTrabalho: false,
                estacoesTrabalho: action.payload
            }


        case RECEIVE_LOGIN_LOGOUTS_HOJE:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_LOGIN_LOGOUTS_HOJE ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingLoginLogoutsHoje: false,
                loginLogoutsHoje: action.payload
            }

        case RECEIVE_LOGIN_LOGOUTS:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_LOGIN_LOGOUTS ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingLoginLogouts: false,
                loginLogouts: action.payload.loginLogouts
            }

        case FETCH_PNEUS_NA_CASA:
            return {
                ...state,
                isFetchingPneusNaCasa: true,
                pneusNaCasa: []
            }
        case RECEIVE_PNEUS_NA_CASA:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_PNEUS_NA_CASA ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingPneusNaCasa: false,
                pneusNaCasa: action.payload
            }
        case FETCH_LISTA_OSs:
            return {
                ...state,
                isFetchingPneusNaCasa: true,
                listaOSs: []
            }
        case RECEIVE_LISTA_OSs:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_LISTA_OSs ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingListaOSs: false,
                listaOSs: action.payload
            }
        case FETCH_PNEUS_RECEBIDOS_HOJE:
            return {
                ...state,
                isFetchingListaOSs: true,
                listaOSs: []
            }
        case RECEIVE_PNEUS_RECEBIDOS_HOJE:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_PNEUS_RECEBIDOS_HOJE ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                isFetchingPneusRecebidosHoje: false,
                pneusRecebidosHoje: action.payload
            }

        case FETCH_PNEUS_SAIDOS_HOJE:
            return {
                ...state,
                isFetchingPneusSaidosHoje: true,
                pneusSaidosHoje: []
            }
        case RECEIVE_PNEUS_SAIDOS_HOJE:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_PNEUS_SAIDOS_HOJE ${action.payload}`)
                action.payload = [];
            }

            return {
                ...state,
                isFetchingPneusSaidosHoje: false,
                pneusSaidosHoje: action.payload
            }
        case FETCH_PNEUS_PRODUZIDOS_HOJE:
            return {
                ...state,
                isFetchingPneusProduzidosHoje: true,
                pneusProduzidosHoje: []
            }
        case RECEIVE_PNEUS_PRODUZIDOS_HOJE:

            console.log("Reducer RECEIVE_PNEUS_PRODUZIDOS_HOJE", action.payload);

            return {
                ...state,
                isFetchingPneusProduzidosHoje: false,
                pneusProduzidosHoje: action.payload.recapadosHoje,
                recapadosHoje: action.payload.recapadosHoje,
                consertadosHoje: action.payload.consertadosHoje,
                retrabalhadosHoje: action.payload.retrabalhadosHoje,
            }
        case FETCH_PNEUS_RECUSADOS_REPROVADOS_HOJE:
            return {
                ...state,
                isFetchingPneusRecusadosReprovadosHoje: true,
                pneusRecusadosReprovadosHoje: []
            }
        case RECEIVE_PNEUS_RECUSADOS_REPROVADOS_HOJE:
            return {
                ...state,
                isFetchingPneusRecusadosReprovadosHoje: false,
                pneusRecusadosHoje: action.payload.recusados,
                pneusReprovadosHoje: action.payload.reprovados
            }
        case RECEIVE_PNEUS_RECEBIDOS_POR_DATA:
            return {
                ...state,
                recebidosPorData: action.payload.recebidosPorData
            }

        case RECEIVE_PNEUS_ENVIADOS_POR_DATA:
            return {
                ...state,
                enviadosPorData: action.payload.enviadosPorData
            }
        case RECEIVE_PNEUS_CONCLUIDOS_POR_DATA:

            return {
                ...state,
                recapadosPorData: action.payload.recapadosPorData,
                consertadosPorData: action.payload.consertadosPorData,
                retrabalhadosPorData: action.payload.retrabalhadosPorData
            }
        case RECEIVE_PNEUS_RECUSADOS_REPROVADOS_POR_DATA:
            return {
                ...state,
                recusadosPorData: action.payload.recusadosPorData,
                reprovadosPorData: action.payload.reprovadosPorData
            }

        case RECEIVE_PROCESSOS:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_PROCESSOS ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                processos: action.payload
            }

        case RECEIVE_OS_SLA:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_OS_SLA ${action.payload}`)
                action.payload = [];
            }
            return {
                ...state,
                osSLA: action.payload
            }

        case RECEIVE_SALDOS:
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_SALDOS ${action.payload}`)
                action.payload.saldos = [];
            }
            return {
                ...state,
                saldos: action.payload.saldos
            }

        case FETCH_METAS:
            return {
                ...state,
                isFetchingMetas: true,
            }

        case RECEIVE_METAS:
            console.log("RECEIVE METAS", action.payload);
            if (action.payload.error) {
                console.log(`ERROR RECEIVE_METAS ${action.payload}`)
                action.payload.metas = [];
            }
            return {
                ...state,
                isFetchingMetas: false,
                metas: action.payload.metas
            }
        case RECEIVE_METAS_PERIODO:
            console.log("RECEIVE METAS PERIODO", action.payload);
            return {
                ...state,
                isFetchingMetas: false,
                metasPeriodo: action.payload.metasPeriodo
            }

        case RECEIVE_DIARIOS_PRODUCAO:
            return {
                ...state,
                isFetchingDiariosProducao: false,
                diariosProducao: action.payload.diariosProducao
            }

        default:
            return state;
    }
}
